import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from './core/services/common.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private toastr: ToastrService

  ) { }

  error(error: any, fallbackMessage: string = 'Something went wrong') {
    let message = fallbackMessage;

    if (error?.error?.detail) {
      message = error.error.detail;
    } else if (typeof error === 'string') {
      message = error;
    } else if (error?.message) {
      message = error.message;
    }

    this.toastr.error(this.getErrorMessage(message));
  }

  getErrorMessage(error) {
    if (typeof error === "object" && error !== null && "error" in error) {
      return (error as Record<string, string>).error;
    }

    const errorStr = typeof error === "string" ? error : JSON.stringify(error);

    try {
      const parsed = JSON.parse(errorStr);
      if (typeof parsed === "object" && parsed !== null && "error" in parsed) {
        return parsed.error;
      }
    } catch (_) {}

    const regex = /string=(["'])(.*?)\1/g;
    const matches = [...errorStr.matchAll(regex)];
    if (matches.length > 0) {
      const lastMatch = matches[matches.length - 1];
      let extracted = lastMatch[2];

      let jsonLike = extracted
        .replace(/'/g, '"')
        .replace(/\bNone\b/g, "null")
        .replace(/\bTrue\b/g, "true")
        .replace(/\bFalse\b/g, "false");

      try {
        const parsed = JSON.parse(jsonLike);
        if (
          typeof parsed === "object" &&
          parsed !== null &&
          "error" in parsed
        ) {
          return parsed.error;
        }
      } catch (_) {}

      return extracted;
    }

    return errorStr;
  }

  success(message: string) {
    this.toastr.success(message);
  }

  info(message: string) {
    this.toastr.info(message);
  }

  warning(message: string) {
    this.toastr.warning(message);
  }
}
